import { ConfigState } from './types';

interface ConfigStore {
  config: ConfigState;
}

const loading = (state: ConfigStore) => state.config.loading;
const getTenant = (state: ConfigStore) => state.config.tenant;
const getConfig = (state: ConfigStore) => state.config;

const configSelector = {
  loading,
  getTenant,
  getConfig,
};

export default configSelector;
